import { HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { COMMON_CONSTANTS, MANAGE_PAIRING } from '../common/core/common.constants';
import { HelperUtilityService } from './helper-utility.service';
import { environment } from '../../environments/environment';
import { AuthHttpService } from './http-wrapper.service';
import { EnvironmentDetailsService } from './environment-details.service';
import { BehaviorSubject } from 'rxjs';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class ManagePairingService {
  private helperUtilSvc: HelperUtilityService
  private httpClient: AuthHttpService;
  private envSvc: EnvironmentDetailsService;
  private utilsSvc: UtilsService;

  public hasGSMandDiggits = new BehaviorSubject<boolean>(false);
  authoringContentData: any;

  constructor(private injector : Injector) {
    this.helperUtilSvc = this.injector.get<HelperUtilityService>(HelperUtilityService);
    this.httpClient = this.injector.get<AuthHttpService>(AuthHttpService);
    this.envSvc = this.injector.get<EnvironmentDetailsService>(EnvironmentDetailsService);
    this.utilsSvc = this.injector.get<UtilsService>(UtilsService);

  }

  setHeaders() {
    return {
      headers: new HttpHeaders(
        {
          'Accept': COMMON_CONSTANTS.HEADER_PROPERTIES.APPLICATION_JSON_KEY,
          'Content-Type': COMMON_CONSTANTS.HEADER_PROPERTIES.APPLICATION_JSON_KEY,
          'Cache-Control': COMMON_CONSTANTS.HEADER_PROPERTIES.NO_CACHE,
          // 'Authorization': this.authToken,
          'B2b-Client': this.helperUtilSvc.getClientId() || '',
          'B2b-Org': this.helperUtilSvc.getOrgID() || '',
          'authType': this.helperUtilSvc.getAuthType() || '',
          'transactionID': this.helperUtilSvc.getTransactionID() || '',
          'authToken':this.helperUtilSvc.getAuthToken() || '',
        },
      ),
    };
  }

  getPairingStatus(request: any) {
    const httpOptions = this.setHeaders();

    if (environment.mocked_all || environment.mocked_endpoints) {
      if (request?.mobileNumbers?.[0] === "7149999999") {
        return this.httpClient.get(this.envSvc.APIGEE_TOKEN_URLS.APIGEE_PAIRING_STATUS_DIGITS_PAIRED);
      } else if (request?.mobileNumbers?.[0] === "7147777777") {
        return this.httpClient.get(this.envSvc.APIGEE_TOKEN_URLS.APIGEE_PAIRING_STATUS_GSM_PAIRED);
      }
      return this.httpClient.get(this.envSvc.APIGEE_TOKEN_URLS.APIGEE_PAIRING_STATUS_UNPAIRED);
    } else {
      return this.httpClient.post(this.envSvc.APIGEE_TOKEN_URLS.APIGEE_PAIRING_STATUS, request,  httpOptions);
    }
  }

  checkEligibility(body: any) {
    const httpOptions = this.setHeaders();

    if (environment.mocked_all || environment.mocked_endpoints) {
      if (body.digitsLine == "7149999999") {
        return this.httpClient.get(this.envSvc.APIGEE_TOKEN_URLS.APIGEE_PAIRING_ELIGIBILITY_VALID);
      }
      return this.httpClient.get(this.envSvc.APIGEE_TOKEN_URLS.APIGEE_PAIRING_ELIGIBILITY_INVALID);
    } else {
      return this.httpClient.post(this.envSvc.APIGEE_TOKEN_URLS.APIGEE_MANAGE_PAIRING_ELIGIBILITY, body, httpOptions);
    }

  }

  submitManagePairRequest(body: any) {
    const httpOptions = this.setHeaders();

    if (environment.mocked_all || environment.mocked_endpoints) {
      return this.httpClient.get(this.envSvc.APIGEE_TOKEN_URLS.APIGEE_MANAGE_PAIRING_SUBMIT_SUCCESS);
    } else {
      return this.httpClient.post(this.envSvc.APIGEE_TOKEN_URLS.APIGEE_MANAGE_PAIRING_SUBMIT, body, httpOptions);
    }
  }

  isGSMLine(productType: string): boolean {
    return productType == "G" || productType == "GSM";
  }

  isDIGITsLine(lineType: string): boolean {
    // Per BAU DIGITs we were checking lineType == "D" or "V"
    // but now for Manage pairing we will only support DIGITs
    // rate plan hence only lineType = "D"
    return lineType == "D";
  }

  updateHasGSMAndDIGITsSessionStorage(ban: string, has: boolean) {
    let tracker = JSON.parse(sessionStorage.getItem(COMMON_CONSTANTS.BAN_HAS_GSM_AND_DIGITS) || '{}');
    tracker[ban] = has;
    sessionStorage.setItem(COMMON_CONSTANTS.BAN_HAS_GSM_AND_DIGITS, JSON.stringify(tracker))
  }

  getFormLineLabels(action, lineType, productType) {
    this.authoringContentData = this.utilsSvc.getContentDataFromSession();

    const selectedLineDIGIT = this.isDIGITsLine(lineType);
    const selectedLineGSM = this.isGSMLine(productType);

    const labels = {
      "digitLineLabel": "Watch Line",
      "gsmLineLabel": "Voice line"
    };

    if (selectedLineDIGIT && action == MANAGE_PAIRING.PAIR) {
      labels.digitLineLabel = this.authoringContentData.managePairing.lineLabel1;
      labels.gsmLineLabel = this.authoringContentData.managePairing.lineLabel2;
    } else if (selectedLineDIGIT && action == MANAGE_PAIRING.UNPAIR) {
      labels.digitLineLabel = this.authoringContentData.managePairing.lineLabel1;
      labels.gsmLineLabel = this.authoringContentData.managePairing.lineLabel3;
    } else if (selectedLineGSM && action == MANAGE_PAIRING.PAIR) {
      labels.digitLineLabel = this.authoringContentData.managePairing.lineLabel4;
      labels.gsmLineLabel = this.authoringContentData.managePairing.lineLabel5;
    } else if (selectedLineGSM && action == MANAGE_PAIRING.UNPAIR) {
      labels.digitLineLabel = this.authoringContentData.managePairing.lineLabel6;
      labels.gsmLineLabel = this.authoringContentData.managePairing.lineLabel5;
    }

    return labels;
  }
}
